"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorContainer = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2021 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var fullHeightWidthStyle = {
    height: "100%",
    width: "100%",
};
exports.ErrorContainer = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement("div", { className: "gd-visualization-content", style: fullHeightWidthStyle },
        react_1.default.createElement("div", { className: "info-label" },
            react_1.default.createElement("div", { style: fullHeightWidthStyle }, children))));
};
//# sourceMappingURL=ErrorContainer.js.map